import { useQuery } from 'react-query';

import {
  ApplicationCount,
  applicationsCountsKey,
  getEnterpriseApplicationsCountsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';



type useGetEnterpriseApplicationsCountssProps = {
  query?: string;
  companyId?: string | number;
};

export const useGetEnterpriseApplicationsCounts = ({
  query,
  companyId
}: useGetEnterpriseApplicationsCountssProps) => {

  const { data: applicationsCountsData, isLoading: isLoadingApplicationsCounts } = useQuery<ApplicationCount[]>({
    queryKey: [applicationsCountsKey, query, companyId],
    queryFn: () =>
      axiosInstance
        .get(
          getEnterpriseApplicationsCountsRoute +
          (query ? `?query=${query}` : '') +
          (query && companyId ? `&company_id=${companyId}` : companyId ? `?company_id=${companyId}` : '')
        )

        .then((res) =>
          res.data?.object
            ? (Object.values(res.data.object) as ApplicationCount[])
            : res?.data,
        ),
     refetchOnWindowFocus: false,
  });

  return {
    applicationsCountsData,
    isLoadingApplicationsCounts
  };
};
